import React, { useState } from "react";
import Project_head from "../IMG/Project head.png";
import bootcamp from "../IMG/bootcamp.gif";
import ask from "../IMG/ask.jpg";
import aldaraz from "../IMG/aldaraz.gif";
import Plantscrape from "../IMG/Plantscrape.gif";
import wds from "../IMG/WDS.gif";
import makerble from "../IMG/chat.gif";
import portfolio from "../IMG/portfolio.gif";
import ewent from "../IMG/ewent.gif";
import foodies from "../IMG/Foodie.PNG";
import ranter from "../IMG/Ranter.png";
import houseofmarktechs from "../IMG/houseofmarktechs.PNG";
import inwenttree from "../IMG/inwenttree.PNG";
import shorts from "../IMG/shorts.gif";
import docify from "../IMG/docify.gif";
import map from "../IMG/map.gif";
import tokenly from "../IMG/tokenly.gif";


function Project_main() {
  const projects = [
    {
      category: "Web Development",
      projects: [
        {
          img: docify,
          title: "Docify – Smart Document Workspace with AI ",
          duration: "April - 2025",
          description: `• Developed "Docify", a full-stack document management platform with AI-powered content generation, rich-text editing, and file upload support using React.js, Node.js, MongoDB, and TailwindCSS.\n
                    • Implemented real-time card interactions with drag & drop, instant delete, in-place editing, and .doc export, enhancing UX with Framer Motion and responsive design.\n
                    • Integrated OpenRouter.ai for smart document generation and Intro.js for an interactive onboarding experience, improving user engagement and feature discoverability.`,
          tech: " React.js, Express.js, MongoDB, Tailwind CSS, Visual Studio Code",
          link: "https://docify-puce.vercel.app/",
          link_tile: "Website",
        },
        {
          img: ewent,
          title: "E-went - Event Management Platform",
          duration: "January - 2025",
          description: `• Developed an event management platform enabling users to create, manage, and attend events seamlessly\n
                    • Built the frontend with React.js, integrated Express.js for backend, and used MongoDB for data storage.\n
                    • Implemented real-time communication with Socket.IO and secured authentication using JWT.`,
          tech: " React.js, Express.js, Tailwind CSS, Visual Studio Code",
          link: "https://e-went.vercel.app/",
          link_tile: "Website",
        },
        {
          img: shorts,
          title: "Shorts - URL Shortner",
          duration: "March - 2025",
          description: `• Developed a full-stack Link Shortener & Analytics Dashboard using React.js, Node.js, and MongoDB.\n
                    • Implemented features like JWT authentication, custom aliases, link expiry, and click tracking with Chart.js.\n
                    • Designed a responsive UI with TailwindCSS and deployed the backend on Render with CI/CD integration.`,
          tech: " React.js, Express.js, MongoDB, Tailwind CSS, Visual Studio Code",
          link: "https://shorts-url-shortner.vercel.app/",
          link_tile: "Website",
        },
        {
          img: houseofmarktechs,
          title: "House Of Marktechs",
          duration: "Feburary - 2025",
          description: `Modern Frontend Development: Built using React.js with Vite, ensuring faster performance and optimized builds for a seamless user experience.\n
                    Responsive & Efficient Design: Styled with Tailwind CSS for a fully responsive and visually appealing interface across all devices, enhancing user accessibility.\n
                    Optimized Data Handling: Integrated JSONPlaceholder API for dynamic user data and implemented lazy loading to improve performance by loading content only when needed.`,
          tech: "React.js, Tailwind CSS, JSONPlaceholder API, Lazy loading, Vite",
          link: "https://house-of-marktech-pi.vercel.app/",
          link_tile: "Website",
        },
        {
          img: foodies,
          title: "Foodiees",
          duration: "Feburary - 2025",
          description: `Foodies is a sleek and user-friendly food-ordering landing page built with React.js. It offers a smooth and responsive interface, allowing users to explore and enjoy their favorite meals effortlessly. Designed for an enhanced user experience, it combines modern design with seamless navigation.`,
          tech: "React.js, HTML5, CSS3, Visual Studio Code",
          link: "https://foodies-mu-five.vercel.app/",
          link_tile: "Website",
        },
        {
          img: ranter,
          title: "Ranter - Anonymous Rant System",
          duration: "July - 2025",
          description: `Developed a rant platform allowing users to share thoughts anonymously with 100% privacy.
                    Used PHP for the backend, HTML/CSS for the frontend, and MySQL with XAMPP for 45% faster API calls.
                    Applied responsive design principles, increasing user engagement by 60% and satisfaction rate.`,

          tech: "HTML, CSS, PHP, MYSQL, XAMPP, Visual Studio Code",
          link: "https://ranter.wuaze.com/index.php",
          link_tile: "Website",
        },
        {
          img: inwenttree,
          title: "In-went-tree",
          duration: "January - 2025",
          description: `In-Went Tree is a sleek and responsive front-end web application designed for a smooth user experience. It features a modern UI with dynamic components, ensuring fast performance across devices. Built with cutting-edge web technologies, it delivers an intuitive and visually appealing interface.`,
          tech: "React (Vite), Tailwind CSS, React Icons, VS Code",
          link: "https://in-went-tree.vercel.app/",
          link_tile: "Website",
        },
        {
          img: aldaraz,
          title: "Aldaraz.com - Professional Service Website",
          duration: "October - 2022",
          description: `• Created a responsive service-based website, enhancing user experience through intuitive design.\n
                    • Applied modern web technologies like HTML5, CSS3, and JavaScript to ensure cross-browser compatibility.\n
                    • Focused on performance optimization and mobile-first design principles.`,
          tech: "HTML5, CSS3, JavaScript, Visual Studio Code",
          link: "https://sri-akshat5.github.io/Aldaraz.com/",
          link_tile: "Website",
        },
        {
          img: portfolio,
          title: "My Portfolio",
          duration: "January - 2025",
          description: `• Designed a LinkedIn-inspired portfolio, optimizing user experience by leveraging familiar navigation patterns.\n
                    • Implemented responsive design principles using React.js, Node.js, and tailwind CSS to ensure cross-device compatibility.\n
                    • Focused on intuitive design to showcase projects and skills effectively, enhancing recruiter engagement.`,
          tech: "React.js, Node.js, Tailwind CSS, Visual Studio Code",
          link: "https://akshat-srivastava-navy.vercel.app/",
          link_tile: "Website",
        },
      ],
    },
    {
      category: "Mobile App Development",
      projects: [
        {
          img: bootcamp,
          title: "Bootcamp - Group-Based Chatting Application",
          duration: "August - 2024",
          description: `• Designed and implemented a group-based chat app with broadcast feature, enabling efficient chat.\n
                    • Utilized Firebase for real-time data synchronization and secure user authentication.\n
                    • Optimized the app for cross-platform performance using Flutter and Dart.`,
          tech: "Dart, Flutter, Firebase, Visual Studio Code",
          link: "https://github.com/Sri-Akshat5/Bootcamp",
          link_tile: "Repositories",
        },
        {
          img: ask,
          title: "ASK GPT - AI Chatbot Application",
          duration: "April – 2024",
          description: `• Built an AI chatbot application for Android, providing real-time, conversational interaction using OpenAI API.\n
                    • Integrated natural language processing for enhanced response accuracy and user experience.\n
                    • Leveraged Java and Android Studio to deliver a seamless, performance-optimized application.`,
          tech: "Java, OpenAI API, Android Studio",
          link: "https://github.com/Sri-Akshat5/Ask-GPT",
          link_tile: "Repositories",
        },
      ],
    },
    {
      category: "Software Development",
      projects: [
        {
          img: tokenly,
          title: "Tokenly - Auth as a service",
          duration: "January - 2026",
          description: `• Built multi-tenant Authentication SaaS enabling secure isolated apps at scale improving onboarding efficiency 40%.\n
• Implemented tenant isolation, reducing cross-tenant security risks with separate users, application and policies.\n
• Auto-created configuration with safe defaults and hashing with BCRYPT, ARGON2, PBKDF2, boosting reliability 60%.\n
• Developed JWT stateless auth with refresh tokens and API-key security, improving session protection 70%.`,
          tech: "Spring Boot, Java, MySQL, React.js, Redis",
          link: "https://tokenly.codes/",
          link_tile: "Website",
        },
        {
          img: map,
          title: "USSD - Map",
          duration: "July - 2025",
          description: `• Developed a telecom-grade USSD navigation system for low-internet regions using 90% Spring Boot.\n
• Integrated 2-way location-based directions with paginated USSD flow and SMS fallback via Twilio API.\n
• Engineered backend logic with 4-step session flow, 160-char paging, and 99% success in direction delivery`,
          tech: "Java,Spring Boot, Google Map API, Africa’s Talking, MySQL, Ngrok",
          link: "https://github.com/Sri-Akshat5/USSD-Map",
          link_tile: "Repositories",
        },
        {
          img: wds,
          title: "CCTV Violence Detection System ",
          duration: "August - 2024",
          description: `• Developed an intelligent surveillance system to detect roadside violence using CCTV footage.
                    \n
                    • Implemented advanced video processing algorithms with Python and the Django framework\n
                    • Optimized real-time alerting for authorities, ensuring system scalability and performance.`,
          tech: "Python, Django, Visual Studio Code",
          link: "https://github.com/Sri-Akshat5/Violence-Detection-System",
          link_tile: "Repositories",
        },
      ],
    },

    {
      category: "UI/UX Design",
      projects: [
        {
          img: Plantscrape,
          title: "PlantScrape",
          duration: "October - 2024",
          description: `• Designed an intuitive and responsive interface, enhancing user experience for PlantScrape.\n
                    • Leveraged modern UI/UX tools like Figma and Adobe XD to create visually appealing layouts.\n
                    • Focused on accessibility, performance optimization, and seamless cross-device functionality.`,
          tech: "UI/UX, Figma",
          link: "https://ui-ux-portfolio.blogspot.com/2025/01/plantscrape.html",
          link_tile: "Portfolio",
        },
        {
          img: makerble,
          title: "Makerble",
          duration: "July - 2024",
          description: `• Designed a user-friendly interface for Makerble, ensuring smooth and engaging chat interactions.\n
                    • Utilized modern design principles to create seamless navigation and responsive layouts.\n
                    • Focused on accessibility, real-time interaction design, and optimized user engagement.`,
          tech: "UI/UX, Figma",
          link: "https://ui-ux-portfolio.blogspot.com/2025/01/makerble.html",
          link_tile: "Portfolio",
        },
      ],
    },
  ];

  const [expandedCategories, setExpandedCategories] = useState({});
  const [allExpanded, setAllExpanded] = useState(false);

  const toggleCategory = (index) => {
    setExpandedCategories((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const expandAll = () => {
    const expandedState = projects.reduce(
      (acc, _, index) => ({ ...acc, [index]: true }),
      {}
    );
    setExpandedCategories(expandedState);
    setAllExpanded(true);
  };

  const collapseAll = () => {
    setExpandedCategories({});
    setAllExpanded(false);
  };

  return (
    <>

      <div className="pb-6 px-4 py-6 space-y-6">
        {/* Header Section */}
        <div className="shadow-md rounded-md">
          <img
            src={Project_head}
            alt="Project Head"
            className="w-full h-full object-contain"
          />
        </div>

        {/* Projects Section with Buttons */}
        <div className="pb-4 md:pb-4 md:pt-4 px-6 pt-4 bg-white shadow-md rounded-md">
          <h1 className="text-xl font-bold my-4 tracking-wide">My Projects</h1>

          {/* Expand/Collapse Buttons */}
          <div className="flex justify-end space-x-2 mb-4">
            <button
              onClick={expandAll}
              className="px-4 py-2  text-blue-500 bg-blue-100 hover:text-blue-100 rounded-md shadow hover:bg-blue-500"
            >
              Expand All
            </button>
            <button
              onClick={collapseAll}
              className="px-4 py-2 bg-red-100 text-red-500 rounded-md shadow hover:bg-red-500 hover:text-red-100"
            >
              Collapse All
            </button>
          </div>

          {/* Categories */}
          <div className="space-y-3">
            {projects.map((category, categoryIndex) => (
              <div
                key={categoryIndex}
                className="px-4 pt-4 bg-gray-100 rounded-md shadow-md border"
              >
                {/* Category Title with Toggle Button */}
                <h2
                  className="text-xl font-semibold  pb-4 flex items-center cursor-pointer"
                  onClick={() => toggleCategory(categoryIndex)}
                >
                  {expandedCategories[categoryIndex] ? (
                    <span className="text-green-500 mr-2">-</span>
                  ) : (
                    <span className="text-red-500 mr-2">+</span>
                  )}
                  {category.category} <span className="ml-2 px-2.5 py-0.5 text-sm bg-blue-100 text-blue-600 rounded-full">{category.projects.length}</span>
                </h2>

                {/* Projects under the Category */}
                {expandedCategories[categoryIndex] &&
                  category.projects.map((pro, projectIndex) => (
                    <div key={projectIndex} className="pb-6">
                      <div className="flex items-center space-x-4 p-5 bg-gray-50 rounded-md shadow-sm hover:shadow-md transition-all duration-200">
                        <div className="flex-1 space-y-2">
                          <h2 className="text-xl font-semibold text-gray-800">
                            {pro.title}
                          </h2>
                          <p className="text-base text-gray-500 italic">
                            {pro.duration}
                          </p>
                          <p className="text-base text-gray-500">
                            {pro.description.split("\n").map((line, i) => (
                              <span key={i} className="block">
                                {line.trim()}
                              </span>
                            ))}
                          </p>
                          <p className="text-base text-green-500">
                            <strong className="text-black">Tech Stack:</strong>{" "}
                            {pro.tech}
                          </p>
                          <p className="text-base text-blue-500">
                            <strong className="text-black">Link: </strong>
                            <a
                              href={pro.link}
                              target="_blank"
                              rel="noopener noreferrer"
                              className=""
                            >
                              {pro.link_tile}
                            </a>
                          </p>
                          <div className="flex justify-center">
                            <img
                              src={pro.img}
                              alt={pro.title}
                              className="rounded-md"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default Project_main;
